import { AddMunicipalPropertyInventorySelectionInput, AddMunicipalPropertyInventorySelectionMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { refreshMunicipalPropertyManagement } from "../../lib/refresh-municipal-property-management";

import { addMunicipalPropertyInventorySelectionMutationDocument } from "./add-municipal-property-inventory-selection-mutation.gql";

type SelectionRequest = AddMunicipalPropertyInventorySelectionInput & { workspaceId: string };

export function useAddMunicipalPropertyInventorySelection(): UseMutationResult<AddMunicipalPropertyInventorySelectionMutation, Error, SelectionRequest> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ inventoryId, propertyIdList }: SelectionRequest): Promise<AddMunicipalPropertyInventorySelectionMutation> =>
      createOperationClient("AddMunicipalPropertyInventorySelection").request(addMunicipalPropertyInventorySelectionMutationDocument, { input: { inventoryId, propertyIdList } }),
    onSuccess: async (_data, { workspaceId, propertyIdList }): Promise<void> => {
      await refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId, propertyIdList } }).catch(() => undefined);
    },
  });
}
